import type { ApolloQueryResult } from "@apollo/client";
import type {
  IFinancialsSheetQuery,
  IFinancialsSheetQueryVariables,
} from "components/financials/modern/graphql/__generated__/FinancialsSheetQuery.generated";
import type { IFinancialsTemplateFieldsFragment } from "components/financials/modern/graphql/fragments/__generated__/FinancialsTemplateFieldsFragment.generated";
import Templates from "components/financials/modern/templates/Templates";
import classNames from "components/ui/classNames";
import type { IIndicatorDataSource, IPlatformVertical } from "types/graphqlTypes";

export interface TemplatesWrapperProps {
  vertical: IPlatformVertical;
  indicatorDataSource: IIndicatorDataSource;
  financialsTemplate: IFinancialsTemplateFieldsFragment | null;
  systemTemplate: IFinancialsTemplateFieldsFragment | null;
  overridingTemplate: IFinancialsTemplateFieldsFragment | null;
  renderingTemplate: IFinancialsTemplateFieldsFragment | null;
  onChange?: (template: IFinancialsTemplateFieldsFragment | null) => void;
  onRefetchFinancialsTemplate: (
    newVariables: Partial<IFinancialsSheetQueryVariables>,
  ) => Promise<ApolloQueryResult<IFinancialsSheetQuery>>;
}

export default function TemplatesWrapper({ systemTemplate, ...props }: TemplatesWrapperProps) {
  if (!systemTemplate) {
    return (
      <div
        className={classNames(
          "flex h-10 w-full animate-pulse flex-nowrap items-center rounded-xl bg-slate-200/60",
          "dark:bg-slate-950 dark:text-slate-300",
          "w-full lg:max-w-52",
        )}
      />
    );
  }

  return <Templates systemTemplate={systemTemplate} {...props} />;
}
